import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    console.log(user, loading)
    if (loading) {
        return <div className="min-h-screen bg-gray-900 flex items-center justify-center">
            <div className="text-white text-xl">Loading...</div>
        </div>;
    }

    if (!user) {
        return <Navigate to="/admin/login" />;
    }

    return children;
}

export default ProtectedRoute;